module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": _vm.to,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "btn btn-dark btn-sm text-xs"
  }, [_c('i', {
    class: ("fa " + _vm.icon)
  }), _vm._v(" " + _vm._s(_vm.label) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41daa99a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/historico-alteracoes/components/LinkHistoricoAlteracoes.vue
// module id = 1619
// module chunks = 17